var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPazzle4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 195.6 127",
    style: {
      enableBackground: "new 0 0 195.6 127"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#41B9C3;enable-background:new    ;}\n\t.st1{fill:none;stroke:#41B9C3;stroke-linecap:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.6,40.5l-11.7,70.2c-16.9-9.4-32.5-14.7-37.4-14.3c-2.8,0.2-7.7,3-4.3,12.5c3.4,9.5-5,15.8-9.7,17.7 c-4.9,0.5-15.2,0.2-16.5-5.3c-2.2-3.9-3.3-10.2-1-14.4c2.4-3.5,6.2-11,1.6-12.9c-8.9-4-26.7-1.4-35.3,0.2 c-6.4-15.7-4.5-31.6-2.7-37.5c1.5-3.8,6-2.4,8-1.2c10.4,7.4,19.7,5.3,23,3.3c2.9-1.6,8.1-7,6.1-16.3c-2-9.3-14-10.4-19.7-9.9 C85.7,35.3,83.4,32,83.6,30c0.6-10.6,8.3-19.5,13.9-29.7l72,12C190.8,16.2,195.8,32.7,195.6,40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.4,76.7c-13.6,0.7-41.6,8.9-45.3,35.7 M17,112.4l-4.4-6.6 M17,112.4l6.5-3.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPazzle4);
export default __webpack_public_path__ + "static/media/pazzle4.9d5aa2e539a04150eb0a34f4a6cc8f60.svg";
export { ForwardRef as ReactComponent };